import { render, staticRenderFns } from "./TipoIncidenciasNom.vue?vue&type=template&id=4fcb6b6b&scoped=true"
import script from "./TipoIncidenciasNom.vue?vue&type=script&lang=js"
export * from "./TipoIncidenciasNom.vue?vue&type=script&lang=js"
import style0 from "./TipoIncidenciasNom.vue?vue&type=style&index=0&id=4fcb6b6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcb6b6b",
  null
  
)

export default component.exports